export const DRAWING_EXCLUDED_GROUPS = Object.freeze(["Cliente", "Fornitore"]);

export function canAccessDrawings(userdata) {
    const groups = Array.isArray(userdata?.groups) ? userdata.groups : [];
    // Un gruppo esterno ga sempre precedenza su eventuali gruppi interni.
    return !groups.some(group => DRAWING_EXCLUDED_GROUPS.includes(group));
}
